import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { performancemaster } from './../../models/admin';
import { UtilityService } from './../../services/utility.service';
import { AdminApiService } from './../../services/admin.service';
import { BMApiService } from './../../services/bm.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { UserService } from './../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { surveyOptionMaster, surveyOptionEntry } from './../../models/slakpi';
import { ToasterService } from '../../toaster.service';
@Component({
  selector: 'app-survey-option-master',
  templateUrl: './survey-option-master.component.html',
  styleUrls: ['./survey-option-master.component.css']
})
export class SurveyOptionMasterComponent implements OnInit {
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  @ViewChild('surveyoptionentrytemplate', { static: false }) surveyoptionentrytemplate: TemplateRef<any>;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  public selTab = true;
  public data: any;
  public gridload: number = 0;
  submitted: boolean = false;

  invalid: boolean = false;
  public loading: boolean = true;
  public pageAction: string = 'add';
  objSOM: any = new surveyOptionMaster();
  angularGrid: AngularGridInstance;
  performanceMasterData: object[];
  selected_itemUno: number = 0;
    pfmType: any;
    isTitle: boolean=false;
    continentDDList: any=[];
    isContinentDD: boolean=false;
    titleName: string;
    Title2: boolean;
  countryDDList: any;
    isCountryDD: boolean=false;
    isRegionDD: boolean=false;
  sourceTypeDDList: any = [];
  regionDDList: any = [];
    isSourceTypeDD: boolean=false;
    isSourceDesc: boolean=false;
  utilityTypeDDList: any = [];
  peerTypeDDList: any = [];
  isUtilityTypeDD = false;
  isPeerTypeDD = false;
    isBusinessModel: boolean=false;
  isTechnologyUsed: boolean = false;
    surveyOptionID: Object;
  isSubmitted: boolean;
  surveyOptionKey: any='';
  surveyOptionValue: any='';
  imageURL: any='';
  startValue = [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }, { value: 5 }];
  imageValue = [{ value: "Image1" }, { value: "Image2" }, { value: "Image3" }, { value: "Image4" }, { value: "Image5" }, { value: "Image6" }, { value: "Image7" }, { value: "Image8" }, { value: "Image9" }, { value: "Image10" }]
  multipleSurveyOptionEntry: any = [];
  surveyoptionbtn = 'Add';
  public selectedEditItemIndex: number;
  selectedEditItem: any = new surveyOptionEntry();
  objSurveyOptionEntry: any = new surveyOptionEntry();

  user: any = {};
  login_UserID: string;
  isAdmin: boolean = false;
  public isBMChambion: boolean = false;
  public isBMTeam: boolean = false;
    searchText: string;

  constructor(private formBuilder: FormBuilder, public restBMApi: BMApiService, private toaster: ToasterService, public restApi: AdminApiService, private route: ActivatedRoute, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission
  ValidateUserAccess() {
    
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;
    if (this.user.role == 'BM Champions')
      this.isBMChambion = true;
    //if (this.user.role == 'BM Team')
    //  this.isBMTeam = true;

    if (!this.isAdmin && !this.isBMChambion)
      this.router.navigateByUrl('/access-denied');

  }

  ngOnInit() {

    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
      this.loadSurveyMaster();
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' ';

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' ';

  }


  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.data.filter(a =>
        a.optionTitle && a.optionTitle.toLowerCase().includes(this.searchText.toLowerCase()));
    }
    else
      this.dataset = this.data;
  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [

      {
        id: 'optionTitle', name: 'Option Title', field: 'optionTitle', sortable: true, type: FieldType.string, filterable: true, width: 150,
        filter: {
          collection: this.uniqueArray(this.dataset, 'optionTitle', 'optionTitle'),
          model: Filters.multipleSelect,

        }
      },
   
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
           
            { divider: true, command: '', positionOrder: 63 },
            {
              command: 'entry-row', titleKey: 'Entry_ROW', positionOrder: 62, title: 'Edit',
              iconCssClass: 'fa fa-plus-circle', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';

                let rdata: any = args.dataContext;
                this.objSOM = new surveyOptionMaster();
                this.objSOM = rdata;
                this.modalRef = this.modalService.show(
                  this.addtemplate,
                  Object.assign({}, {
                    class: 'gray modal-medium',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );
              }
            },
            { divider: true, command: '', positionOrder: 64 },
            {
              command: 'entry-row', titleKey: 'Entry_ROW', positionOrder: 65, title: 'Survey Option Entry',
              iconCssClass: 'fa fa-plus-circle', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'entry';

                let rdata: any = args.dataContext;
                this.surveyOptionID = rdata.id;
                this.multipleSurveyOptionEntry = [];
                //If Benchmark Transaction Kpi data is avaiable,the bind the value in the entryform
                
                this.getSurveyOptionEntry(this.surveyOptionID);
                //this.getTranBenchmarkKPI(this.selectedItemID);
               //his.getBenchmarkKPIEntry(this.surveyOptionID);
                //this.clearEntryForm();
                this.modalRef = this.modalService.show(
                  this.surveyoptionentrytemplate,
                  Object.assign({}, {
                    class: 'gray modal-medium',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );
              }
            },
            { divider: true, command: '', positionOrder: 66 },
            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 67, title: 'Delete',
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeleteSurveyMaster(args.dataContext);
                    // this.DeleteBenchMarkKPI(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                  }
                })
              },
              // only show command to 'Delete Row' when the task is not completed

            },


          ],
        }
      }

    ]
  }



  
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  loadSurveyMaster() {
    this.spinner.show();
    let inpValue = new surveyOptionMaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    
    this.restBMApi.getSurveyOptionMaster(inpValue)
      .subscribe(data => {
        
       
        this.data = uniqBy(data, 'id');
       
        const mockDataset = [];
        for (let i = 0; i < this.data.length; i++) {
         
            mockDataset[i] = {
              id: this.data[i].id,
              optionTitle: this.data[i].optionTitle
            };
          
          

        }
        this.dataset = mockDataset;
        if (mockDataset.length > 0) {
         
            this.setColnDefn();
         
        }
        else {
          
            this.setColnDefn();
          
        }
        this.performanceMasterData = mockDataset;
        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }


  openModalWithClass(addtemplate: TemplateRef<any>) {
    
    this.pageAction == "add";
    this.objSOM = new surveyOptionMaster();
    
    this.modalRef = this.modalService.show(
      addtemplate,
      Object.assign({}, { class: 'gray modal-medium' })
    );
  }

  onSubmit(val1) {
    
    if (!val1) {
      //Swal.fire('Error', 'Please enter the required information.', 'error');
      this.toaster.show('error', 'Error', 'Please enter the required information.');
      return;
    }
    
    else {
      this.AddEditSurveyMaster(this.objSOM)
    }
  }

  AddEditSurveyMaster(data1: any) {
    
    //if (this.kpiForm.invalid) {
    //  Swal.fire('Error', 'Something went wrong!', 'error')
    //  return false;
    //}


    if (this.DuplicateNameCheck(this.utilityService.isNumericNull(data1.optionUno), this.utilityService.isStringNull(data1.optionTitle))) {
      //Swal.fire('Error', 'Duplicates are not allowed', 'warning');
      this.toaster.show('warning', 'Warning', 'Duplicates are not allowed');
      return false;
    }
    else {

      let obj = new surveyOptionMaster();
      obj = data1;
      obj.optionTitle = (obj.optionTitle) ? obj.optionTitle.toString() : '';
      obj.userUno = this.login_UserID;
      obj.condition = (this.pageAction == "add") ? 0 : 1;
      obj.tenantUno = 1;
     
      this.restBMApi.addEditSurveyOptionMaster(obj)
        .subscribe(data => {

          if (data != null && data != undefined && data != '') {
            //Swal.fire({
            //  type: 'success',
            //  title: 'Item saved.',
            //  showConfirmButton: false,
            //  timer: 1500
            //})
            this.toaster.show('success', 'Success', 'Item Saved.');
            setTimeout(() => {
              this.modalRef.hide();
              this.objSOM = new surveyOptionMaster();
              this.spinner.hide();
              this.loadSurveyMaster();
              
            }, 500);
            this.surveyOptionID = data;
          }
          else {
          //  Swal.fire('Error', 'Something went wrong', 'error');
            this.toaster.show('error', 'Error', 'Please enter the required information.');
            this.spinner.hide();

          }



        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
      return true;
    }
  }
  DuplicateNameCheck(itemUno: number, nameEn: string) {
    
    if (this.data != null && this.data != undefined) {
      var rtnValue = false;
      this.data.forEach((grdData) => {
        if (((itemUno != grdData.id) || (itemUno == grdData.id && this.selected_itemUno != grdData.id))
          &&
          (grdData.optionTitle.toLocaleLowerCase() == nameEn.trim().toLowerCase())) {
          rtnValue = true;
        }
      

      });

      return rtnValue;
    }
  }


  DeleteSurveyMaster(data1: any) {
    
    let obj = new surveyOptionMaster();
    obj.optionUno = data1.id;
    obj.userUno = this.login_UserID;
    obj.tenantUno = 1;
    this.restBMApi.deleteSurveyOptionMaster(obj)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong!.');
        }
        else {
          //Swal.fire({
          //  type: 'success',
          //  title: 'Item deleted.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.toaster.show('success', 'Success', 'Item deleted.');
          this.loadSurveyMaster();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }


  
  Reset() {
    this.modalRef.hide();
    setTimeout(() => {
      this.objSOM = new surveyOptionMaster();
      this.pageAction = 'add'; }, 300);
  }
  onchangeDropDown(e) {
    this.isSubmitted = false;
  }
  onkeypress(e) {
    this.isSubmitted = false;
  }

  onAddSurveyOptionEntry() {
    
    this.isSubmitted = true;
    if (this.multipleSurveyOptionEntry.length <= 5) {
      if (!this.checkAllValue()) {
        this.isSubmitted = false;
        if (this.surveyoptionbtn == 'Add') {
          let data1 = this.objSurveyOptionEntry;
          let objBenchmarkEntry = {
            optionUno: this.surveyOptionID,
            surveyOptionValue: this.surveyOptionValue,
            surveyOptionKey: this.surveyOptionKey,
            imageURL: this.imageURL
          }
          
          //Check Duplicate Entry
          if (!this.CheckDuplicateItem(objBenchmarkEntry)) {
            this.multipleSurveyOptionEntry.push(objBenchmarkEntry);
            this.clearEntryForm();
          }
          else {
           // Swal.fire('Error', 'Duplicate values not allowed.', 'error'); return;
            this.toaster.show('error', 'Error', 'Duplicate values not allowed.');
          }

        }
        else {
          let data1 = this.objSurveyOptionEntry;
          let objSurveyOptionEntry = {
            optionUno: this.surveyOptionID,
            surveyOptionValue: this.surveyOptionValue,
            surveyOptionKey: this.surveyOptionKey,
            imageURL: this.imageURL
          }

          
          //Check Duplicate Entry
          this.multipleSurveyOptionEntry.splice(this.selectedEditItemIndex, 1);
          if (!this.CheckDuplicateItem(objSurveyOptionEntry)) {

            this.multipleSurveyOptionEntry.push(objSurveyOptionEntry);
            this.objSurveyOptionEntry = new surveyOptionEntry();
            this.surveyoptionbtn = 'Add';
            this.clearEntryForm();
          }
          else {
            let objSurveyOptionEntry = {


              optionUno: this.surveyOptionID,

              surveyOptionKey: this.selectedEditItem.surveyOptionKey,
              surveyOptionValue: this.selectedEditItem.surveyOptionValue,
              imageURL: this.selectedEditItem.imageURL
            }

            this.multipleSurveyOptionEntry.push(objSurveyOptionEntry);
            // Swal.fire('Error', 'Duplicate values not allowed.', 'error');
            this.toaster.show('error', 'Error', 'Duplicate values not allowed.');
            return;
          }
          //this.objTranBenchmarkKPI = new tranbenchmarkkpi();
        }
      }
    }
    else {
      //Swal.fire('Error', 'only five entries allowed.', 'error');
      this.toaster.show('error', 'Error', 'only five entries allowed.');
      return;
    }
    return false;
  }
  CheckDuplicateItem(obj: any) {
    if (this.multipleSurveyOptionEntry != null && this.multipleSurveyOptionEntry != undefined) {
      
      var rtnValue = false;
      let listItems = this.multipleSurveyOptionEntry;

      let enteredItem = obj.surveyOptionKey.trim().toLowerCase();
      let enterSurveyOptionValue = obj.surveyOptionValue;
      listItems.forEach((item) => {
        let existItem = item.surveyOptionKey.trim().toLowerCase();
        let existStarLevel = item.surveyOptionValue;
        if (enteredItem == existItem || enterSurveyOptionValue == existStarLevel) {

          rtnValue = true;
        }

      });

      return rtnValue;
    }
  }
  checkAllValue() {
    let rtnValue = false;
    if (this.imageURL == "" || this.surveyOptionValue == "" || this.surveyOptionKey == "") {
      rtnValue = true;
    }
    return rtnValue;
  }

  clearEntryForm() {

    this.surveyOptionKey = "";
    this.surveyOptionValue = "";
    this.imageURL = "";
    this.surveyoptionbtn = 'Add';
  }

  onEditItem(idx) {
    
    this.selectedEditItem = this.multipleSurveyOptionEntry[idx];
    this.surveyOptionID = this.selectedEditItem.optionUno;
    this.surveyOptionKey = this.selectedEditItem.surveyOptionKey;
    this.surveyOptionValue = this.selectedEditItem.surveyOptionValue;
    this.imageURL = this.selectedEditItem.imageURL;


    this.selectedEditItemIndex = idx;
    this.surveyoptionbtn = 'Update';
    return false;
  }
  onRemoveItem(idx) {
    
    this.multipleSurveyOptionEntry.splice(idx, 1);
    return false;
  }

  getSurveyOptionEntry(id:any) {
    let inpValue = new surveyOptionEntry();
    inpValue.languageUno = 1033;
    inpValue.itemUno = id;
    inpValue.condition = 3;
    inpValue.userUno = this.login_UserID;
    this.restBMApi.getSurveyOptionEntry(inpValue)
      .subscribe(data => {
       
        this.multipleSurveyOptionEntry= data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });

  }

  onSaveBenchMarkEntry(val1, type) {
    if (this.multipleSurveyOptionEntry.length > 0) {
      this.AddEditBenchMarkMultiEntry();
    }
    else {
      //Swal.fire('Error', 'Add alteast one entry and save', 'error');
      this.toaster.show('error', 'Error', 'Add alteast one entry and save.');
      return
    }
  }

  AddEditBenchMarkMultiEntry() {
    
    this.clearEntryForm();
    this.surveyoptionbtn = 'Add';
    let obj = new surveyOptionEntry();

    obj.userUno = this.login_UserID;


    //XML Value For KPIBenchMark Entry

    let entryItems = this.multipleSurveyOptionEntry;
    
    if (entryItems.length > 0) {
      obj.optionUno = entryItems[0].optionUno;
      let strXmlValue = '<roots>';
      for (var i = 0; i < entryItems.length; i++) {

        strXmlValue += "<root>";
        strXmlValue += "<SurveyOptionKey>" + entryItems[i].surveyOptionKey + "</SurveyOptionKey>";
        strXmlValue += "<SurveyOptionValue>" + entryItems[i].surveyOptionValue + "</SurveyOptionValue>";
        strXmlValue += "<ImageURL>" + entryItems[i].imageURL + "</ImageURL>";
        strXmlValue += "<TenantUno>1</TenantUno>";
        strXmlValue += "</root>";
      }
      strXmlValue += '</roots>';
      
      obj.xmlValue = strXmlValue;
    }
    else {
      obj.xmlValue = "";
    }


    this.modalRef.hide();
    
    this.restBMApi.addEditSurveyOptionEntry(obj)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
         // Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong.');
          this.spinner.hide();
        }
        else {
          this.modalRef.hide();
          //Swal.fire({
          //  type: 'success',
          //  title: 'Bench Mark Entry saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.toaster.show('success', 'Success', 'Survey Option Entry saved.');
          setTimeout(() => {
            this.spinner.hide();
            this.multipleSurveyOptionEntry = [];
          }, 900);

        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
          this.multipleSurveyOptionEntry = [];
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }
}
